module.exports = __webpack_public_path__ + "static/MtrIntro-26c1389513bdee0c9f3dcc8ba6285b7f.webp";